<div style="padding: 16px; box-sizing: border-box; height: calc(94vh - 48px); display: flex; flex-direction: column; overflow: hidden">
  <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 12px">
    <mat-checkbox [formField]="naytaKasitellytKentta">Näytä käsitellyt</mat-checkbox>
    @if (lataa()) {
      <mat-spinner [diameter]="20"></mat-spinner>
    }
  </div>

  @if (!lataa() && palautteet().length === 0) {
    <div class="dark-gray-text">Ei palautteita.</div>
  }

  <div style="display: flex; gap: 16px; flex: 1 1 auto; min-height: 0">
    <div style="flex: 1 1 auto; min-width: 0; min-height: 0; overflow-y: auto; overscroll-behavior: contain">
      @for (palaute of palautteet(); track palaute.avain) {
        <div
          (click)="valitsePalaute(palaute)"
          style="border: 1px solid #ddd; border-radius: 4px; padding: 12px; margin-bottom: 10px; cursor: pointer"
          [style.opacity]="palaute.kasitelty ? 0.6 : 1"
          [style.border-color]="valittuPalaute()?.avain === palaute.avain ? '#1976d2' : '#ddd'"
          [style.background]="valittuPalaute()?.avain === palaute.avain ? '#f0f6ff' : 'transparent'"
        >
          <div style="display: flex; justify-content: space-between; gap: 12px">
            <div>
              <a [routerLink]="['/asiakkaat', palaute.asiakasAvain, 'kirjanpito']" (click)="$event.stopPropagation()" style="font-weight: bold">{{ palaute.asiakasNimi }}</a>
              <div class="dark-gray-text" style="font-size: 12px">
                Kirjaus {{ palaute.kirjausnumero ?? '—' }} · {{ palaute.luotu | date: 'd.M.yyyy HH:mm' }} · {{ annaKirjanpitajanNimi(palaute.ilmoittajaUid) }}
              </div>
            </div>
            <div (click)="$event.stopPropagation()">
              @if (palaute.kasitelty) {
                <span class="dark-gray-text" style="font-size: 12px">Käsitelty {{ palaute.kasiteltyAika | date: 'd.M.yyyy HH:mm' }} · {{ annaKirjanpitajanNimi(palaute.kasittelijaUid) }}</span>
              } @else {
                <app-secondary-button (click)="merkitseKasitellyksi(palaute)" [disabled]="merkitaanKasitellyiksi().has(palaute.avain)" actionId="Merkitsi AI-kirjausehdotuspalautteen käsitellyksi">Merkitse käsitellyksi</app-secondary-button>
              }
            </div>
          </div>

          <div style="margin-top: 8px; white-space: pre-wrap">{{ palaute.palauteTeksti }}</div>

          <div class="dark-gray-text" style="font-size: 12px; margin-top: 8px">
            @if (palaute.confidenceLevel !== null) {
              <div>Varmuustaso: {{ palaute.confidenceLevel }} %</div>
            }
            @if (palaute.perustelu) {
              <div>Perustelu: {{ palaute.perustelu }}</div>
            }
            @if (palaute.ehdotetutTilit?.length) {
              <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 6px; margin-top: 2px">
                <span>Ehdotetut tilit:</span>
                @for (tili of annaEhdotetutTilit(palaute); track $index) {
                  <span style="display: inline-block; padding: 1px 8px; border-radius: 10px; background: #fff; border: 1px solid #c7d2e0; color: #333; font-family: monospace">{{ tili }}</span>
                }
              </div>
            }
            @if (palaute.malli) {
              <div>Malli: {{ palaute.malli }}</div>
            }
          </div>
        </div>
      }
    </div>

    @if (valittuPalaute()) {
      <div style="flex: 0 0 45%; max-width: 45%; min-height: 0; height: 100%; display: flex; flex-direction: column; gap: 12px">
        <div style="flex: 0 0 auto; max-height: 45%; overflow-y: auto; overscroll-behavior: contain; padding: 4px 8px">
          @if (kirjausLataa()) {
            <mat-spinner diameter="24" style="margin: 24px auto"></mat-spinner>
          } @else if (!naytettavaKirjaus()) {
            <div style="color: #888; text-align: center; padding: 24px 0">Kirjausta ei löytynyt</div>
          } @else {
            <div class="dark-gray-text" style="font-size: 12px; padding: 0 4px 2px">Kirjauksen tämänhetkinen tila (ei tilannekuva palautteen antohetkeltä)</div>
            <div class="kl" style="margin: 8px 4px; max-width: 100%">
              <div class="kl-paasisalto">
                <div class="kirj-info">
                  <span class="dark-gray-text pkn pnc">{{ naytettavaKirjaus().kirjausnumero }}</span>
                  <div class="dark-gray-text" style="font-size: 90%; display: inline-block">{{ formatPvm(naytettavaKirjaus().p) }}</div>
                  <div
                    class="kirj-sum"
                    [class.red-text]="0 > naytettavaKirjaus().kirjauksenSumma && naytettavaKirjaus().maksutavanTunniste !== '9999'"
                    [class.green-text]="naytettavaKirjaus().kirjauksenSumma > 0 && naytettavaKirjaus().maksutavanTunniste !== '9999'"
                  >
                    {{ naytettavaKirjaus().kirjauksenSumma | number: '1.2-2' }} €
                  </div>
                  @if (naytettavaKirjaus().kirjauksenSaajaTaiMaksaja) {
                    <div
                      [class.light-blue-text]="naytettavaKirjaus().tunniste !== 'omaverotasmaytys_oy_erapaiva' && naytettavaKirjaus().tunniste !== 'omaverotasmaytys_oy_kk' && naytettavaKirjaus().tunniste !== 'omaverotasmaytys_tmi_yearly'"
                      [class.dark-purple-text]="naytettavaKirjaus().tunniste === 'omaverotasmaytys_oy_erapaiva' || naytettavaKirjaus().tunniste === 'omaverotasmaytys_oy_kk' || naytettavaKirjaus().tunniste === 'omaverotasmaytys_tmi_yearly'"
                      class="tstm"
                    >
                      {{ naytettavaKirjaus().kirjauksenSaajaTaiMaksaja }}
                    </div>
                  }
                  @if (naytettavaKirjaus().kirjauksenSaajaTaiMaksajaIban) {
                    <div style="padding-top: 1px">{{ naytettavaKirjaus().kirjauksenSaajaTaiMaksajaIban }}</div>
                  }
                  @if (naytettavaKirjaus().kirjauksenViitenumero) {
                    <div style="padding-top: 7px">Viitenumero: {{ naytettavaKirjaus().kirjauksenViitenumero }}</div>
                  }
                  @if (naytettavaKirjaus().vat) {
                    <div style="padding-bottom: 8px">
                      <span>VAT-numero: </span>
                      <span>{{ naytettavaKirjaus().vat }}</span>
                    </div>
                  }
                  @if (naytettavaKirjaus().kirjauksenViesti) {
                    <div class="dark-gray-text" style="padding-top: 7px">{{ naytettavaKirjaus().kirjauksenViesti }}</div>
                  }
                  @if (naytettavaKirjaus().kirjauksenLemonaidViesti || naytettavaKirjaus().userApiMessage) {
                    <div style="padding-top: 7px; font-weight: bold; color: black">
                      {{ (naytettavaKirjaus().kirjauksenLemonaidViesti ?? '') + (naytettavaKirjaus().userApiMessage ? ' ' + naytettavaKirjaus().userApiMessage : '') }}
                    </div>
                  }
                </div>
                <div>
                  <div class="kra dark-gray-text">
                    <div class="kna">Tili</div>
                    <div class="kda">Debet</div>
                    <div class="kka">Kredit</div>
                    <div class="kaa">Alv</div>
                  </div>
                  @for (kirjausrivi of naytettavaKirjaus().rivit; track $index) {
                    <div class="kr" [class.lukittu]="onAlvRivi(kirjausrivi)">
                      <div class="knc" [class.lukittu]="onAlvRivi(kirjausrivi)">
                        <div class="kn">{{ kirjausrivi.t }}</div>
                        <div class="knr">{{ annaTilinNimi(kirjausrivi.t) }}</div>
                      </div>
                      <div class="kd" [class.lukittu]="onAlvRivi(kirjausrivi)">{{ kirjausrivi.d > 0 ? (kirjausrivi.d | number: '1.2-2') : '' }}</div>
                      <div class="kk" [class.lukittu]="onAlvRivi(kirjausrivi)">{{ kirjausrivi.k > 0 ? (kirjausrivi.k | number: '1.2-2') : '' }}</div>
                      <div class="ka" [class.lukittu]="onAlvRivi(kirjausrivi)">{{ annaAlvLyhenne(kirjausrivi) }}</div>
                    </div>
                  }
                  <div class="krj dark-gray-text">
                    <div class="kna"></div>
                    <div class="kda">{{ debetYhteensa(naytettavaKirjaus().rivit) | number: '1.2-2' }}</div>
                    <div class="kka">{{ kreditYhteensa(naytettavaKirjaus().rivit) | number: '1.2-2' }}</div>
                    <div class="kaa"></div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>

        <div #tositeContainer style="flex: 1 1 auto; overflow-y: auto; overflow-x: hidden; overscroll-behavior: contain; border: 1px solid #eee; border-radius: 8px; padding: 8px">
          @if (naytettavatTositteetJaSivut() === null) {
            <mat-spinner diameter="24" style="margin: 40px auto"></mat-spinner>
          } @else if (!naytettavatTositteetJaSivut().length) {
            <div style="color: #888; text-align: center; padding-top: 40px">Kirjaukseen ei ole liitetty tositetta</div>
          } @else {
            <div app-kirjanpito-tosite-naytto [piilotaYlaControllit]="true" [naytaRuksi]="false" [scrollContainerRef]="tositeContainerRef" [naytettavaKirjausObservable]="tyhjaKirjausObservable" [naytettavatTositteetJaSivut]="naytettavatTositteetJaSivut()"></div>
          }
        </div>
      </div>
    }
  </div>
</div>
